<template>
  <c-flex mr="-30px" ml="-30px" flexDirection="column" justifyContent="center">
    <c-box
      backgroundImage="url(/img/brandstore/store_header.jpg)"
      backgroundPosition="center"
      backgroundSize="cover"
      backgroundRepeat="no-repeat"
      borderRadius="base"
      mr="xl"
      v-chakra="{
        '@media (min-width: 2048px)': {
          mr: '0',
        },
      }"
      :mt="{ base: 'xl', xl: '3rem' }"
      :ml="{ base: 'xl', xl: '2xl' }"
      maxWidth="100%"
      height="35vw"
      backgroundColor="white"
      maxHeight="600px"
      :minHeight="{ base: '275px', sm: '450px' }"
    >
      <c-box
        :width="{ base: '100%', sm: 'md' }"
        :maxWidth="{ base: '100%', sm: '90%' }"
        :height="{ base: '100%', sm: 'auto' }"
        :pt="{ base: '4xl', sm: '32' }"
        :background="{ base: 'hsla(0,0%,100%,.7)', sm: 'none' }"
        borderRadius="base"
        pl="2xl"
      >
        <c-box
          :background="{ base: 'none', sm: 'hsla(0,0%,100%,.7)' }"
          borderRadius="base"
          :p="{ base: 'xl', md: '0 0 0 10px' }"
        >
          <CHeading as="h3" fontSize="xl">
            {{ $t("brandstore.header.preHeader") }}
          </CHeading>
          <CHeading as="h1" mb="14px">
            {{ $t("brandstore.header.headerText") }}
          </CHeading>
          <c-text>{{ $t("brandstore.header.content") }}</c-text>
        </c-box>
      </c-box>
    </c-box>

    <c-flex maxWidth="100%" justifyContent="center" :ml="{ md: 'xl' }" :mr="{ md: 'xl' }">
      <c-flex
        mt="3xl"
        mb="xl"
        :maxWidth="{ base: '90%', lg: '70%' }"
        alignItems="center"
        flexDirection="column"
        justifyContent="space-between"
        background="white"
        :padding="{ base: '22px 33px 33px', md: '33px 44px 40px', lg: '33px 86px 40px' }"
        borderRadius="base"
        boxShadow="base"
      >
        <c-text mt="xl" mb="xl">{{ $t("brandstore.linkBox.content") }}</c-text>
        <c-link :href="linkUrl" target="iLOQ brandstore">
          <c-button
            variation="solid"
            background="brand.beige"
            borderWidth="0px"
            color="black"
            :ml="{ md: 'md' }"
            :mr="{ base: 'auto', md: '0' }"
            :href="linkUrl"
          >
            {{ $t("brandstore.linkBox.buttonText") }}
          </c-button>
        </c-link>
      </c-flex>
    </c-flex>

    <c-box>
      <c-text color="brand.grayDark" fontWeight="300" m="xl" mb="0" textAlign="center">{{
        $t("brandstore.disclaimer")
      }}</c-text>
    </c-box>
  </c-flex>
</template>

<script lang="ts">
import config from "@/config";
import Button from "@/design-system/elements/Button.vue";
import { CBox, CButton, CFlex, CHeading, CLink, CText } from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "Brandstore",
  components: {
    Button,
    CHeading,
    CButton,
    CFlex,
    CText,
    CLink,
    CBox,
  },
  computed: {
    linkUrl(): any {
      return config.get("brandstoreUrl");
    },
  },
});
</script>
